import { defineMessages } from 'react-intl';

export const messages: {
	searchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyLinkIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholderDefault: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholderWithAtlassianIntelligence: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholderWithRovo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchIconLabel: {
		id: 'input_search_icon_label',
		defaultMessage: 'Search',
		description:
			'Accessible label for the search icon displayed inside the main search textfield on the search page.',
	},
	clearIconLabel: {
		id: 'input_clear_icon_label',
		defaultMessage: 'Clear search',
		description:
			'Accessible label for the clear button icon in the search textfield that removes the current search query when clicked.',
	},
	copyLinkIconLabel: {
		id: 'input_copy_link_icon_label',
		defaultMessage: 'Copy link',
		description:
			'Accessible label for the copy link icon button in the search textfield that copies the current search URL to the clipboard.',
	},
	inputPlaceholderDefault: {
		id: 'input_placeholder_default',
		defaultMessage: 'Search for anything',
		description: 'Placeholder text in primary search input',
	},
	inputPlaceholderWithAtlassianIntelligence: {
		id: 'input_placeholder_with_atlassian_intelligence',
		defaultMessage: 'Search or ask anything',
		description: 'Placeholder text in primary search input with Atlassian Intelligence',
	},
	inputPlaceholderWithRovo: {
		id: 'input_placeholder_with_rovo',
		defaultMessage: 'Search or ask Rovo',
		description: 'Placeholder text in primary search input with Rovo',
	},
});
